
















import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import JobsDataTable from "../../components/DataTables/JobsDataTable.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as temp from "../../_store/temp.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import NoPage from "../../components/Error/NoPage.vue";

import * as data from "../../_store/data.module";

@Component({
  components: {
    CardTitle,
    JobsDataTable,
    NoPage
  }
})
export default class Proposte extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;
  private candidatureDialogParams: object;

  private listaProposte: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Proposte Lavorative",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Offerta",
          value: "nomeProposta"
        },
        {
          text: "Istituto",
          value: "nomeIstituto"
        },
        {
          text: "Settore",
          value: "nomeArticolazione"
        },
        {
          text: "Ruolo",
          value: "ruolo"
        },
        {
          text: "Tipo Contratto",
          value: "tipoContratto"
        },
        {
          text: "Sede Lavoro",
          value: "sede"
        },
        {
          text: "Dettagli Offerta",
          value: "dettagliOfferta",
          sortable: false,
          width: "1%"
        },
        {
          text: "Candidature",
          value: "candidatureProposteLavoro",
          sortable: false,
          width: "1%"
        },
        // {
        //   text: "Mofica Offerta",
        //   value: "modificaOfferta",
        //   sortable: false,
        //   width: "1%"
        // },
        {
          text: "Elimina Offerta",
          value: "eliminaOfferta",
          sortable: false,
          width: "1%"
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI PROPOSTA",
        type: "jobOffer"
      }
    };
    this.candidatureDialogParams = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Data Candidatura",
          value: "dataCandidatura"
        },
        {
          text: "Curriculum Vitae",
          value: "curriculum",
          width: "1%"
        },
        {
          text: "Colloquio Avvenuto",
          value: "colloquioAvvenuto",
          width: "1%"
        }
      ],
      records: []
    };
    this.createDialogParams = {
      visible: true,
      type: "proposteLavoro"
    };
    this.listaProposte = [];
  }

  loadProposte() {
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var payload = {
      idAzienda: enterpriseInfo.idAzienda
    };
    data
      .dispatchListaProposteLavoroAzienda(this["$store"], payload)
      .then(result => {
        this.dataTableParams.records = result;
        this.listaProposte = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            bus.$emit("loadMenu");
            this.loadProposte();
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadProposte", () => {
      this.loadProposte();
    });
  }
}
